// extracted by mini-css-extract-plugin
export default {"room_card":"Room_room_card__OXuKh","back-button":"Room_back-button__6IJCB","leaderboard-table":"Room_leaderboard-table__dK31+","active-row":"Room_active-row__pjtEe"};